module.exports = __webpack_public_path__ + "img/tongzhi.ac3fab22.svg";